import { Link } from 'react-router-dom';
import type { Episode } from '@/mocks/episodes';

interface EpisodeCardProps {
  episode: Episode;
  compact?: boolean;
}

export default function EpisodeCard({ episode, compact = false }: EpisodeCardProps) {
  return (
    <Link
      to={`/episode/${episode.id}`}
      data-product-shop
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-300/40 hover:border-primary-500/60 transition-colors cursor-pointer"
    >
      <div className={`relative w-full ${compact ? 'h-56' : 'h-56 sm:h-64'} overflow-hidden bg-background-200`}>
        <img
          src={episode.cover}
          alt={`无颜之月第${episode.number}集 ${episode.title} 剧照封面`}
          title={`无颜之月第${episode.number}集 ${episode.title} 在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent" />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-md bg-primary-500 text-background-50 dark:text-foreground-950 text-xs font-heading font-semibold tracking-wide">
          第 {episode.number} 集
        </span>
        <span className="absolute top-3 right-3 w-9 h-9 rounded-full bg-background-50/70 backdrop-blur flex items-center justify-center text-foreground-900 opacity-0 group-hover:opacity-100 transition-opacity">
          <i className="ri-play-fill text-lg" />
        </span>
      </div>
      <div className="p-4">
        <h3 className="font-heading font-medium text-foreground-950 text-base mb-1 truncate group-hover:text-primary-400 transition-colors">
          {episode.title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2.5">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {episode.airDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {episode.duration}
          </span>
        </div>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2">{episode.synopsis}</p>
      </div>
    </Link>
  );
}